import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { Shield, Mail, Lock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Please fill all fields'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/admin/login`, { email, password });
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_data', JSON.stringify(res.data.admin));
      toast.success('Welcome back, Admin!');
      navigate('/admin');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#2D2424] px-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md p-8 rounded-2xl border-0 shadow-2xl bg-white">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#F2A900]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-[#F2A900]" />
          </div>
          <h1 className="text-2xl font-bold text-[#2D2424]">Admin Panel</h1>
          <p className="mt-2 text-sm text-[#78716C]">Login to VivahRang Admin Dashboard</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <Label className="text-sm font-medium text-[#2D2424]">Email</Label>
            <div className="relative mt-1.5">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#78716C]" />
              <Input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@vivahrang.com"
                className="pl-10 h-11 rounded-lg border-[#E7E5E4]"
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <Label className="text-sm font-medium text-[#2D2424]">Password</Label>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#78716C]" />
              <Input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="pl-10 h-11 rounded-lg border-[#E7E5E4]"
                data-testid="admin-password-input"
              />
            </div>
          </div>
          <Button type="submit" disabled={loading}
            className="w-full bg-[#D9381E] hover:bg-[#B91C1C] text-white rounded-full py-5 font-semibold"
            data-testid="admin-login-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <p className="mt-6 text-center text-xs text-[#78716C]">
          Default: admin@vivahrang.com / admin123
        </p>
      </Card>
    </div>
  );
}
